import { React, useEffect, useMemo, useState } from "react";
import colors from "./constants/Colors";
import axios from "axios";
import AxiosInstance from "./Axios";
import { MaterialReactTable } from "material-react-table";
import Dayjs from "dayjs";
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  QuestionMarkRounded,
  InfoOutlined,
  RollerShades,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import "./styles.css";
import ToggleLinkCell from "./ToggleLinkCell";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const Home = () => {
  const [mySocialMediaData, setMySocialMediaData] = useState();
  const [loadingSocialMediaTable, setLoadingSocialMediaTable] = useState(true);
  const comsCsvColumns = [
    { label: "Communication Activity Name", key: "title" },
    { label: "Description", key: "description" },
    { label: "Who? Target audience", key: "audience" },
    { label: "How? Communication channel", key: "type" },
    { label: "Outcome", key: "outcomes" },
    { label: "Status", key: "status" },
  ];
  const [myWebsiteData, setMyWebsiteData] = useState();
  const [loadingWebsiteTable, setLoadingWebsiteTable] = useState(true);

  const [myEventsData, setMyEventsData] = useState();
  const [myComsData, setMyComsData] = useState();
  const [isSocial, setIsSocial] = useState(false);

  const [loadingEventsTable, setLoadingEventsTable] = useState(true);

  const [myScientificData, setMyScientificData] = useState();
  const [loadingScientificTable, setLoadingScientificTable] = useState(true);

  const project_id = localStorage.getItem("project_id");
  const [picNumber, setPicNumber] = useState(null); // Example picNumber

  // const GetData = () => {
  //   AxiosInstance.get(`projects/${project_id}/socialmedia`,{
  //     headers: {
  //         "Authorization": `Bearer ${localStorage.getItem('access_token')}`,
  //     }
  // }).then((res) => {
  //     setMySocialMediaData(res.data)
  //     console.log(res.data)
  //     setLoadingSocialMediaTable(false)
  //   })
  //   .catch((error) => console.error('Error fetching events data: ', error));
  // }

  const generateCSVData = () => {
    return myComsData.map((event) => ({
      title: event.title, // Adjust to match your actual data structure
      description: event.place,
      type: event.type,
      outcomes: event.titleParticipation,
      status: event.nature,
      audience: event.audience,
    }));
  };

  const GetData = () => {
    // Construct the base URL for the request
    let url = `projects/${project_id}/socialmedia/`;

    // Append pic_number if it's available
    if (picNumber) {
      url += `?pic_number=${picNumber}`;
    }

    // Perform the Axios GET request with the constructed URL
    AxiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    })
      .then((res) => {
        const processedData = res.data.map((item) => ({
          ...item,
          audience: item.audiences.join(", "),
        }));
        setMySocialMediaData(processedData);

        console.log("social media ", processedData);
        setLoadingSocialMediaTable(false);
      })
      .catch((error) => {
        console.error("Error fetching social media data: ", error);
      });
  };

  const GetWebsiteData = () => {
    AxiosInstance.get(`projects/${project_id}/websites/`)
      .then((res) => {
        const processedData = res.data.map((item) => ({
          ...item,
          audience: item.audiences.join(", "),
        }));
        setMyWebsiteData(processedData);
        console.log(processedData);
        setLoadingWebsiteTable(false);
      })
      .catch((error) => console.error("Error fetching events data: ", error));
  };

  const GetEventsData = () => {
    AxiosInstance.get(`projects/${project_id}/events/`)
      .then((res) => {
        const processedData = res.data.map((item) => ({
          ...item,
          audience: item.audiences.join(", "),
        }));
        setMyEventsData(processedData);
        setMyComsData(processedData);

        console.log("eventtss", processedData);
        setLoadingEventsTable(false);
      })
      .catch((error) => console.error("Error fetching events data: ", error));
  };

  const GetScientificData = () => {
    AxiosInstance.get(`projects/${project_id}/scientifics/`)
      .then((res) => {
        const processedData = res.data.map((item) => ({
          ...item,
          audience: item.audiences.join(", "),
        }));
        setMyScientificData(processedData);
        console.log(res.data);
        setLoadingScientificTable(false);
      })
      .catch((error) => console.error("Error fetching events data: ", error));
  };

  const Getproject = async () => {
    console.log("projectsss", project_id);
    const response = await axios.get(
      ` https://eutracker.rdiup.com/v1/project/${project_id}/`
    );
    console.log("responsesss", response);

    setIsSocial(response.data.isSocial);
    console.log("projectssocial", isSocial);
  };

  useEffect(() => {
    if (project_id && project_id != null) {
      GetData();
      GetWebsiteData();
      GetEventsData();
      GetScientificData();
      Getproject();
    } else {
      console.log("no projects");
    }
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "status", // access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Social Media</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              1 row per publication
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "activity",
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Type of activities</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              Type of social media publication
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "description", // normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Description</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              Brief description of the activity
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "link", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Link</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              Link
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },
      {
        accessorKey: "reportingPeriod", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Reporting Period</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              RP1 or RP2 or RP3
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "audience", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Type of Audience</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Select key target audience
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "estimation", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Estimation of Reached People</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Rough estimation
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "participating_partners", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Contributors</p>
            <span
              style={{ fontSize: 12, fontWeight: "400", color: "gray" }}
            ></span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => {
          const contributors = cell.getValue();
          if (!contributors || contributors.length === 0) return "";

          const names = contributors.map((partner) => partner.name).join(", ");
          return names;
        },
      },

      /*{
        accessorFn: (row) => Dayjs(row.start_date).format(`DD-MM-YYYY`),
        header: 'Start date',
        size: 150,
      },
      {
        accessorFn: (row) => Dayjs(row.end_date).format(`DD-MM-YYYY`),
        header: 'End date',
        size: 150,
      },*/
    ],
    []
  );

  const csvColumns = [
    { label: "Social Media", key: "status" },
    { label: "Type of Activities", key: "activity" },
    { label: "Description", key: "description" },
    { label: "Link", key: "link" },
    { label: "Reporting Period", key: "reportingPeriod" },
    { label: "Type of Audience", key: "audience" },
    { label: "Estimation of Reached People", key: "estimation" },
  ];

  const websiteCsvColumns = [
    { label: "Audience", key: "audience" },
    { label: "Estimation", key: "estimation" },
    { label: "ID", key: "id" },
    { label: "Link", key: "link" },
    { label: "Status", key: "status" },
    { label: "Description", key: "description" },
    { label: "Dissemination data  ", key: "dateDissemination" },

    { label: "Notes", key: "notes" },
    { label: "Reporting Period", key: "reportingPeriod" },
    { label: "Type", key: "type" },
  ];

  const eventsCsvColumns = [
    { label: "Audience", key: "audience" },
    // { label: "End Date", key: "end_date" },
    { label: "Estimation", key: "estimation" },
    { label: "Link", key: "link" },
    { label: "Nature", key: "nature" },
    { label: "Description", key: "place" },
    { label: "Reporting Period", key: "reportingPeriod" },
    { label: "Start Date", key: "start_date" },
    { label: "Title", key: "title" },
    { label: "Title Participation", key: "titleParticipation" },
    { label: "Type", key: "type" },
  ];

  const scientificCsvColumnsv2 = [
    { label: "Dissemination activity name", key: "publicationTitle" },
    { label: "Type of activity", key: "status" },
    { label: "Audience", key: "audience" },
    { label: "Short Description", key: "shortDescription" },
    { label: "Status of acitivity", key: "openAccess" },
    { label: "Authors", key: "authors" },
    { label: "Date of Publication", key: "datePublication" },
    { label: "DOI", key: "doi" },
    { label: "Estimation", key: "estimation" },
    { label: "Other Link", key: "otherLink" },
    { label: "Reporting Period", key: "reportingPeriod" },
    { label: "Repository Link", key: "repositoryLink" },
    { label: "Title", key: "title" },
  ];

  const scientificCsvColumns = [
    { label: "Type", key: "type" },
    { label: "Title", key: "publicationTitle" },
    { label: "Authors", key: "authors" },
    { label: "Title of the journal or equivalent", key: "title" },
    { label: "Number", key: "shortDescription" },
    { label: "Peer-reviewed", key: "peerReviewed" },
    { label: "Open Access", key: "openAccess" },
    { label: "PID (published version of record)", key: "repositoryLink" },
    { label: "PID of deposited publication", key: "pidd" },
  ];

  const generateCSVDataS = () => {
    return myScientificData.map((event) => ({
      name: event.publicationTitle, // Adjust to match your actual data structure
      type: event.status,
      audience: event.audience,
      description: event.shortDescription,
      status: event.openAccess,
    }));
  };

  const disseCsvColumns = [
    { label: "Dissemination activity name", key: "notes" },
    { label: "What? Type of dissemination activity", key: "type" },
    { label: "Who? Target audience Reached", key: "audiences" },
    { label: "Why? Description", key: "description" },
    { label: "Status of the dissemination activity", key: "status" },
  ];

  const generateCSVDataD = () => {
    return myScientificData.map((event) => ({
      name: event.publicationTitle, // Adjust to match your actual data structure
      type: event.status,
      audience: event.audience,
      description: event.shortDescription,
      status: event.openAccess,
    }));
  };

  const websiteColumns = useMemo(
    () => [
      {
        accessorKey: "notes", //access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Name of dissemination</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              Use 1 row per publication
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "type", //access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Type of dissemination</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              Clustering, training, meetings
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "audiences", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Audience</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Select key target audience
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "description", //access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Short description</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              {" "}
              Details about the dissemination
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "status", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Status of the activity (Y/N)</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Status
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "reportingPeriod", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Reporting Period</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              RP1 or RP2 or RP3
            </span>
          </Box>
        ),
        size: 200,
      },

      {
        accessorKey: "link",
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Link</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Link
            </span>
          </Box>
        ),
        size: 150,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },

      {
        accessorFn: (row) => Dayjs(row.dateDissemination).format(`DD-MM-YYYY`),
        header: "Date",
        size: 150,
      },

      {
        accessorKey: "estimation", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Estimation of reached people</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Rough estimation
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ row }) => {
          const estimation = row.original.estimation || 0;
          const audiences = Array.isArray(row.original.audiences)
            ? row.original.audiences
            : [];
          const totalEstimation = estimation * audiences.length;
          return <span>{totalEstimation}</span>;
        },
      },
      {
        accessorKey: "participating_partners", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Contributors</p>
            <span
              style={{ fontSize: 12, fontWeight: "400", color: "gray" }}
            ></span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => {
          const contributors = cell.getValue();
          if (!contributors || contributors.length === 0) return "";

          const names = contributors.map((partner) => partner.name).join(", ");
          return names;
        },
      },
    ],
    []
  );

  const eventsColumns = useMemo(
    () => [
      {
        accessorKey: "type", //access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Channel of activities</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Conference, video, etc
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "title",
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Title of the activity</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Name of the activity
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "place", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p> Description </p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Details about the activity
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "titleParticipation", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Outcomes</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Outcomes of the event
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "nature", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p> Status of participation</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Ongoing, delivered ...
            </span>
          </Box>
        ),
        size: 200,
      },

      {
        accessorFn: (row) => Dayjs(row.start_date).format(`DD-MM-YYYY`),
        header: "Date",
        size: 150,
      },
      /* {
        accessorFn: (row) => Dayjs(row.end_date).format(`DD-MM-YYYY`),
        header: "End date",
        size: 150,
      }, */

      {
        accessorKey: "link", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Link</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Link
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },

      {
        accessorKey: "reportingPeriod", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Reporting Period</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              RP1 or RP2 or RP3
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "audiences", //normal accessorKey
        header: "Type of audience",
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Type of audience</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Select key target audience
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "estimation", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Estimation of Reached audiences</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Rough estimation
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ row }) => {
          const estimation = row.original.estimation || 0;
          const audiences = Array.isArray(row.original.audiences)
            ? row.original.audiences
            : [];
          const totalEstimation = estimation * audiences.length;
          return <span>{totalEstimation}</span>;
        },
      },
      {
        accessorKey: "participating_partners", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Contributors</p>
            <span
              style={{ fontSize: 12, fontWeight: "400", color: "gray" }}
            ></span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => {
          const contributors = cell.getValue();
          if (!contributors || contributors.length === 0) return "";

          const names = contributors.map((partner) => partner.name).join(", ");
          return names;
        },
      },
    ],
    []
  );

  const scientificColumns = useMemo(
    () => [
      {
        accessorKey: "type", //access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p> Publication type</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Article, book, chapters, etc.,
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "status", //access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p> Publication Status</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              pendind, published
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "authors",
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Authors</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Surname, name
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "publicationTitle", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Title</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Title of the publication
            </span>
          </Box>
        ),
        size: 200,
      },

      {
        accessorKey: "title", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Name of Journal or equivalent</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Title of the jounal, etc.
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorFn: (row) => Dayjs(row.datePublication).format(`DD-MM-YYYY`),
        header: "Date",
        size: 150,
      },
      {
        accessorKey: "shortDescription", //normal accessorKey
        header: "Number",
        size: 200,
      },
      {
        accessorKey: "repositoryLink", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>PID link</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              DOI link, etc.
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },
      {
        accessorKey: "publisher", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p> publisher (If Available)</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              publisher
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },
      {
        accessorKey: "openAccess", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Open Access (Y/N)</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Answer YES if it is an open access journal
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "link", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Repository Link</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              other publication link
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },
      {
        accessorKey: "reportingPeriod", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Reporting Period</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              RP1 or RP2 or RP3
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "audiences", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Type of audience</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Select key target audience
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "estimation", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Estimation of Reached People</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Rough estimation
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ row }) => {
          const estimation = row.original.estimation || 0;
          const audiences = Array.isArray(row.original.audiences)
            ? row.original.audiences
            : [];
          const totalEstimation = estimation * audiences.length;
          return <span>{totalEstimation}</span>;
        },
      },
      {
        accessorKey: "participating_partners", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Contributors</p>
            <span
              style={{ fontSize: 12, fontWeight: "400", color: "gray" }}
            ></span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => {
          const contributors = cell.getValue();
          if (!contributors || contributors.length === 0) return "";

          const names = contributors.map((partner) => partner.name).join(", ");
          return names;
        },
      },
    ],
    []
  );

  const scientificColumnsv2 = useMemo(
    () => [
      {
        accessorKey: "publicationTitle", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Dissemination activity name</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Name of activity
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "status", //access nested data with dot notation
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p> Type of activity</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Scientific, conferences, clustering other (please specify)
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "audience", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Type of audience</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Select key target audience
            </span>
          </Box>
        ),
        size: 200,
      },
      {
        accessorKey: "shortDescription", //normal accessorKey
        header: "Short Description",
        size: 200,
      },
      {
        accessorKey: "openAccess", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Status of the activity (Y/N)</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Status
            </span>
          </Box>
        ),
        size: 200,
      },

      {
        accessorKey: "authors",
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Authors</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Surname, name
            </span>
          </Box>
        ),
        size: 150,
      },
      {
        accessorKey: "title", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Title (if exists)</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Title of the article
            </span>
          </Box>
        ),
        size: 200,
      },

      {
        accessorFn: (row) => Dayjs(row.datePublication).format(`DD-MM-YYYY`),
        header: "Date",
        size: 150,
      },

      {
        accessorKey: "doi", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>DOI</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Url if available
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },
      {
        accessorKey: "otherLink", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Other Link (If Available)</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Other link if DOI is not available
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },

      {
        accessorKey: "repositoryLink", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Repository Link</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Only required if there is not a DOI <br /> or other link accessing
              the complete text
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ cell }) => <ToggleLinkCell value={cell.getValue()} />,
      },
      {
        accessorKey: "reportingPeriod", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Reporting Period</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              RP1 or RP2 or RP3
            </span>
          </Box>
        ),
        size: 200,
      },

      {
        accessorKey: "estimation", //normal accessorKey
        header: (
          <Box sx={{ marginTop: -2 }}>
            <p>Estimation of Reached People</p>
            <span style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
              Rough estimation
            </span>
          </Box>
        ),
        size: 200,
        Cell: ({ row }) => {
          const estimation = row.original.estimation || 0;
          const audiences = Array.isArray(row.original.audiences)
            ? row.original.audiences
            : [];
          const totalEstimation = estimation * audiences.length;
          return <span>{totalEstimation}</span>;
        },
      },
    ],
    []
  );

  const generateCSV = () => {};

  const [selectedPartnerID, setSelectedPartnerID] = useState(null);
  const [partners, setPartners] = useState([]);
  const [is_admin, setIs_admin] = useState(false);
  const user_id = localStorage.getItem("user_id");

  // Fetch partners when the component mounts
  useEffect(() => {
    setIs_admin(localStorage.getItem("is_admin"));

    const getPartners = () => {
      const url = `projects/${project_id}/get_partners/`;

      AxiosInstance.get(url)
        .then((res) => {
          console.log("Partners data:", res.data);
          setPartners(res.data);
        })
        .catch((err) => {
          console.error(
            "Error fetching partners:",
            err.response ? err.response.data : err.message
          );
        });
    };

    getPartners();
  }, [project_id]);

  // Fetch both social media and website data based on the selected partner
  useEffect(() => {
    if (selectedPartnerID) {
      const getData = async () => {
        try {
          const [socialMediaRes, websitesRes, eventsRes, scientificsRes] =
            await Promise.all([
              AxiosInstance.get(
                `projects/${project_id}/socialmedia/?pic_number=${selectedPartnerID}`
              ),
              AxiosInstance.get(
                `projects/${project_id}/websites/?pic_number=${selectedPartnerID}`
              ),
              AxiosInstance.get(
                `projects/${project_id}/events/?pic_number=${selectedPartnerID}`
              ),
              AxiosInstance.get(
                `projects/${project_id}/scientifics/?pic_number=${selectedPartnerID}`
              ),
            ]);

          console.log("Social Media data:", socialMediaRes.data);
          console.log("Website data:", websitesRes.data);
          console.log("events data:", eventsRes.data);
          console.log("scientifics data:", scientificsRes.data);

          setMySocialMediaData(socialMediaRes.data);
          setMyWebsiteData(websitesRes.data);
          setMyEventsData(eventsRes.data);
          setMyComsData(eventsRes.data);

          setMyScientificData(scientificsRes.data);
        } catch (err) {
          console.error(
            "Error fetching data:",
            err.response ? err.response.data : err.message
          );
        }
      };

      getData();
    }
  }, [selectedPartnerID, project_id]);

  const handlePartnerChange = (event) => {
    setSelectedPartnerID(event.target.value);

    // Perform your filter logic based on selectedPartnerID, or show all when `null`
    if (event.target.value === null) {
      // Handle case for "All" (reset filter)
      GetData();
      GetWebsiteData();
      GetEventsData();
      GetScientificData();
      console.log("Showing all partners' data");
    } else {
      // Filter based on selected partner
      /*    GetData();
      GetWebsiteData();
      GetEventsData();
      GetScientificData();
      console.log("selected", event.target.value, mySocialMediaData);
      filterdata(event.target.value); */

      console.log(`Filtering data for partner with PIC: ${event.target.value}`);
    }
  };

  const filterdata = (pics) => {
    const filteredData = mySocialMediaData.filter(
      (item) => item.created_by === pics
    );

    const filteredDataE = myEventsData.filter(
      (item) => item.created_by === pics
    );
    const filteredDataW = myWebsiteData.filter(
      (item) => item.created_by === pics
    );
    const filteredDataS = myScientificData.filter(
      (item) => item.created_by === pics
    );

    console.log("selected", pics, mySocialMediaData, filteredData);

    // Do something with filteredData, such as updating the state
    setMySocialMediaData(filteredData);
    setMyEventsData(filteredDataE);

    setMyWebsiteData(filteredDataW);

    setLoadingScientificTable(filteredDataS);

    console.log("selected filter ", mySocialMediaData);
  };

  const role = localStorage.getItem("role");

  return (
    <div>
      {role != "none" ? (
        <div>
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              marginRight: 3,
              marginBottom: 5,
            }}
          >
            <FormControl fullWidth size="small" sx={{ maxWidth: 200 }}>
              <InputLabel id="partner-select-label">
                Filter By Partners
              </InputLabel>
              <Select
                labelId="partner-select-label"
                value={selectedPartnerID}
                onChange={handlePartnerChange}
                label="Select a partner"
              >
                {/* Add the "All" option */}
                <MenuItem value={null}>All</MenuItem>

                {/* Map over the partners list */}
                {partners.map((partner) => (
                  <MenuItem key={partner.pic} value={partner.pic}>
                    {partner.name} ({partner.pic})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <br />

          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            {/* <h2 style={{color:colors.secondary}}>Website activities and communication</h2> */}
            <h2 style={{ color: colors.secondary }}>
              <span>
                Communication activities<span style={{ color: "red" }}> *</span>
              </span>{" "}
            </h2>
            <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
              {!loadingEventsTable && myComsData.length > 0 ? (
                <CSVLink
                  data={generateCSVData()}
                  headers={comsCsvColumns}
                  filename="Communication-activities.csv"
                >
                  <Button
                    onClick={generateCSV}
                    variant="contained"
                    sx={{
                      height: 30,
                      borderRadius: 2,
                      backgroundColor: "gray",
                      marginRight: 2,
                    }}
                  >
                    Generate CSV <FileDownloadIcon />
                  </Button>
                </CSVLink>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    height: 30,
                    marginRight: 2,
                    borderRadius: 2,
                    backgroundColor: colors.primary,
                  }}
                  startIcon={<FileDownloadIcon />}
                  disabled // Disabled if no data
                >
                  Generate CSV
                </Button>
              )}
              <Button
                href="/create-events"
                variant="contained"
                sx={{
                  height: 30,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new
              </Button>
            </Box>
          </Grid>
          {loadingEventsTable ? (
            <p>Loading data...</p>
          ) : (
            <MaterialReactTable
              columns={eventsColumns}
              data={myEventsData}
              width={500}
              enableRowActions
              renderRowActions={({ row }) =>
                row.original.created_by == user_id ? (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      color="secondary"
                      component={Link}
                      to={`edit-events/${row.original.id}`}
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton
                      color="error"
                      component={Link}
                      to={`delete-events/${row.original.id}`}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ) : (
                  <Tooltip
                    placement="top"
                    title={"You are not authorized to edit this item."}
                  >
                    <InfoOutlined style={{ marginLeft: 20, color: "orange" }} />
                  </Tooltip>
                )
              }
            />
          )}

          <br />
          {/* // Website Activi *********** */}

          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <h2 style={{ color: colors.secondary }}>
              <span>
                Dissemination activities<span style={{ color: "red" }}> *</span>
              </span>
            </h2>
            <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
              {!loadingWebsiteTable && myWebsiteData.length > 0 ? (
                <CSVLink
                  data={myWebsiteData}
                  headers={disseCsvColumns}
                  filename="Dissemination-activities.csv"
                >
                  <Button
                    onClick={generateCSV}
                    variant="contained"
                    sx={{
                      height: 30,
                      borderRadius: 2,
                      backgroundColor: "gray",
                      marginRight: 2,
                    }}
                  >
                    Generate CSV <FileDownloadIcon />
                  </Button>
                </CSVLink>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    height: 30,
                    borderRadius: 2,
                    backgroundColor: "gray",
                    marginRight: 2,
                  }}
                  startIcon={<FileDownloadIcon />}
                  disabled // Disabled if no data
                >
                  Generate CSV
                </Button>
              )}
              <Button
                href="/create-website"
                variant="contained"
                sx={{
                  height: 30,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new
              </Button>
            </Box>
          </Grid>

          {loadingWebsiteTable ? (
            <p>Loading data...</p>
          ) : (
            <MaterialReactTable
              columns={websiteColumns}
              data={myWebsiteData}
              enableRowActions
              renderRowActions={({ row }) =>
                row.original.created_by == user_id ? (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      color="secondary"
                      component={Link}
                      to={`edit-website/${row.original.id}`}
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton
                      color="error"
                      component={Link}
                      to={`delete-website/${row.original.id}`}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ) : (
                  <Tooltip
                    placement="top"
                    title={"You are not authorized to edit this item."}
                  >
                    <InfoOutlined style={{ marginLeft: 20, color: "orange" }} />
                  </Tooltip>
                )
              }
            />
          )}

          <br />

          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <h2 style={{ color: colors.secondary }}>
              {" "}
              <span>
                Publications<span style={{ color: "red" }}> *</span>
              </span>
            </h2>
            <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
              {!loadingScientificTable && myScientificData.length > 0 ? (
                <CSVLink
                  data={myScientificData}
                  headers={scientificCsvColumns}
                  filename="Publication-activities.csv"
                >
                  <Button
                    onClick={generateCSV}
                    variant="contained"
                    sx={{
                      height: 30,
                      borderRadius: 2,
                      backgroundColor: "gray",
                      marginRight: 2,
                    }}
                  >
                    Generate CSV <FileDownloadIcon />
                  </Button>
                </CSVLink>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    height: 30,
                    borderRadius: 2,
                    backgroundColor: "gray",
                    marginRight: 2,
                  }}
                  startIcon={<FileDownloadIcon />}
                  disabled // Disabled if no data
                >
                  Generate CSV
                </Button>
              )}
              <Button
                href="/create-scientific"
                variant="contained"
                sx={{
                  height: 30,
                  marginTop: 0,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new{" "}
              </Button>
            </Box>
          </Grid>

          {loadingScientificTable ? (
            <p>Loading data...</p>
          ) : (
            <MaterialReactTable
              columns={scientificColumns}
              data={myScientificData}
              enableRowActions
              renderRowActions={({ row }) =>
                row.original.created_by == user_id ? (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      color="secondary"
                      component={Link}
                      to={`edit-scientific/${row.original.id}`}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      component={Link}
                      to={`delete-scientific/${row.original.id}`}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                ) : (
                  <Tooltip
                    placement="top"
                    title={"You are not authorized to edit this item."}
                  >
                    <InfoOutlined style={{ marginLeft: 20, color: "orange" }} />
                  </Tooltip>
                )
              }
              classes={{
                root: "table-cell", // Appliquez la classe CSS aux cellules du tableau
              }}
            />
          )}
          {isSocial && (
            <>
              <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                <h2 style={{ color: colors.secondary }}>
                  Social Media activities
                </h2>
                <Grid>
                  {/* <Button
            onClick={generateCSV}
            variant="contained"
            sx={{ height: 30, marginTop: 2, borderRadius: 2, backgroundColor: 'gray', marginRight: 2 }}
          >
            Generate CSV
          </Button> */}
                  {!loadingSocialMediaTable && mySocialMediaData.length > 0 ? (
                    <CSVLink
                      data={mySocialMediaData}
                      headers={csvColumns}
                      filename="social-media-activities.csv"
                    >
                      <Button
                        onClick={generateCSV}
                        variant="contained"
                        sx={{
                          height: 30,
                          marginTop: 2,
                          borderRadius: 2,
                          backgroundColor: "gray",
                          marginRight: 2,
                        }}
                      >
                        Generate CSV <FileDownloadIcon />
                      </Button>
                    </CSVLink>
                  ) : (
                    <Button
                      variant="contained"
                      sx={{
                        height: 30,
                        marginTop: 2,
                        borderRadius: 2,
                        backgroundColor: "gray", //colors.primary,
                        marginRight: 4,
                      }}
                      startIcon={<FileDownloadIcon />}
                      disabled // Disabled if no data
                    >
                      Generate CSV
                    </Button>
                  )}
                  <Button
                    href="/create"
                    variant="contained"
                    sx={{
                      height: 30,
                      marginTop: 2,
                      borderRadius: 2,
                      backgroundColor: colors.primary,
                    }}
                  >
                    Add new{" "}
                  </Button>
                </Grid>
              </Grid>
              {loadingSocialMediaTable ? (
                <p>Loading data...</p>
              ) : (
                <Grid>
                  <MaterialReactTable
                    columns={columns}
                    data={mySocialMediaData}
                    enableRowActions
                    renderRowActions={({ row }) =>
                      row.original.created_by == user_id ? (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "nowrap",
                            gap: "8px",
                          }}
                        >
                          <IconButton
                            color="secondary"
                            component={Link}
                            to={`edit/${row.original.id}`}
                          >
                            <EditIcon />
                          </IconButton>

                          <IconButton
                            color="error"
                            component={Link}
                            to={`delete/${row.original.id}`}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      ) : (
                        <Tooltip
                          placement="top"
                          title={"You are not authorized to edit this item."}
                        >
                          <InfoOutlined
                            style={{ marginLeft: 20, color: "orange" }}
                          />
                        </Tooltip>
                      )
                    }
                  />
                </Grid>
              )}{" "}
            </>
          )}
        </div>
      ) : (
        <div>
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              marginRight: 3,
              marginBottom: 5,
            }}
          >
            <FormControl fullWidth size="small" sx={{ maxWidth: 200 }}>
              <InputLabel id="partner-select-label">
                Filter By Partners
              </InputLabel>
              <Select
                labelId="partner-select-label"
                value={selectedPartnerID}
                onChange={handlePartnerChange}
                label="Select a partner"
              >
                {/* Add the "All" option */}
                <MenuItem value={null}>All</MenuItem>

                {/* Map over the partners list */}
                {partners.map((partner) => (
                  <MenuItem key={partner.pic} value={partner.pic}>
                    {partner.name} ({partner.pic})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <h2 style={{ color: colors.secondary }}>Social Media activities</h2>
            <Grid>
              {/* <Button
          onClick={generateCSV}
          variant="contained"
          sx={{ height: 30, marginTop: 2, borderRadius: 2, backgroundColor: 'gray', marginRight: 2 }}
        >
          Generate CSV
        </Button> */}
              {!loadingSocialMediaTable && mySocialMediaData.length > 0 ? (
                <CSVLink
                  data={mySocialMediaData}
                  headers={csvColumns}
                  filename="social-media-activities.csv"
                >
                  <Button
                    onClick={generateCSV}
                    variant="contained"
                    sx={{
                      height: 30,
                      marginTop: 2,
                      borderRadius: 2,
                      backgroundColor: "gray",
                      marginRight: 2,
                    }}
                  >
                    Generate CSV <FileDownloadIcon />
                  </Button>
                </CSVLink>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    height: 30,
                    marginRight: 4,
                    marginTop: 2,

                    borderRadius: 2,
                    backgroundColor: colors.primary,
                  }}
                  startIcon={<FileDownloadIcon />}
                  disabled // Disabled if no data
                >
                  Generate CSV
                </Button>
              )}
              <Button
                href="/create"
                variant="contained"
                sx={{
                  height: 30,
                  marginTop: 2,

                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new{" "}
              </Button>
            </Grid>
          </Grid>
          {loadingSocialMediaTable ? (
            <p>Loading data...</p>
          ) : (
            <Grid>
              <MaterialReactTable
                columns={columns}
                data={mySocialMediaData}
                enableRowActions
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      color="secondary"
                      component={Link}
                      to={`edit/${row.original.id}`}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      component={Link}
                      to={`delete/${row.original.id}`}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                )}
              />
            </Grid>
          )}
          <br />

          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            {/* <h2 style={{color:colors.secondary}}>Website activities and communication</h2> */}
            <h2 style={{ color: colors.secondary }}>
              {" "}
              Communication activities
            </h2>
            <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
              {!loadingEventsTable && myComsData.length > 0 ? (
                <CSVLink
                  data={myComsData}
                  headers={eventsCsvColumns}
                  filename="events-activities.csv"
                >
                  <Button
                    onClick={generateCSV}
                    variant="contained"
                    sx={{
                      height: 30,
                      borderRadius: 2,
                      backgroundColor: "gray",
                      marginRight: 2,
                    }}
                  >
                    Generate CSV <FileDownloadIcon />
                  </Button>
                </CSVLink>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    height: 30,
                    marginRight: 2,
                    borderRadius: 2,
                    backgroundColor: colors.primary,
                  }}
                  startIcon={<FileDownloadIcon />}
                  disabled // Disabled if no data
                >
                  Generate CSV
                </Button>
              )}
              <Button
                href="/create-events"
                variant="contained"
                sx={{
                  height: 30,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new
              </Button>
            </Box>
          </Grid>
          {loadingEventsTable ? (
            <p>Loading data...</p>
          ) : (
            <MaterialReactTable
              columns={eventsColumns}
              data={myEventsData}
              width={500}
              enableRowActions
              renderRowActions={({ row }) => (
                <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                  <IconButton
                    color="secondary"
                    component={Link}
                    to={`edit-events/${row.original.id}`}
                  >
                    <EditIcon />
                  </IconButton>

                  <IconButton
                    color="error"
                    component={Link}
                    to={`delete-events/${row.original.id}`}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )}
            />
          )}

          <br />
          {/* // Website Activi *********** */}

          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <h2 style={{ color: colors.secondary }}>
              Dissemination activities
            </h2>
            <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
              {!loadingWebsiteTable && myWebsiteData.length > 0 ? (
                <CSVLink
                  data={myWebsiteData}
                  headers={websiteCsvColumns}
                  filename="Website-activities.csv"
                >
                  <Button
                    onClick={generateCSV}
                    variant="contained"
                    sx={{
                      height: 30,
                      borderRadius: 2,
                      backgroundColor: "gray",
                      marginRight: 2,
                    }}
                  >
                    Generate CSV <FileDownloadIcon />
                  </Button>
                </CSVLink>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    height: 30,
                    marginRight: 2,
                    borderRadius: 2,
                    backgroundColor: colors.primary,
                  }}
                  startIcon={<FileDownloadIcon />}
                  disabled // Disabled if no data
                >
                  Generate CSV
                </Button>
              )}
              <Button
                href="/create-website"
                variant="contained"
                sx={{
                  height: 30,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new
              </Button>
            </Box>
          </Grid>

          {loadingWebsiteTable ? (
            <p>Loading data...</p>
          ) : (
            <MaterialReactTable
              columns={websiteColumns}
              data={myWebsiteData}
              enableRowActions
              renderRowActions={({ row }) => (
                <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                  <IconButton
                    color="secondary"
                    component={Link}
                    to={`edit-website/${row.original.id}`}
                  >
                    <EditIcon />
                  </IconButton>

                  <IconButton
                    color="error"
                    component={Link}
                    to={`delete-website/${row.original.id}`}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )}
            />
          )}

          <br />

          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <h2 style={{ color: colors.secondary }}> Publications</h2>
            <Box sx={{ display: "flex", gap: 2, marginTop: 2 }}>
              {!loadingScientificTable && myScientificData.length > 0 ? (
                <CSVLink
                  data={myScientificData}
                  headers={scientificCsvColumns}
                  filename="Publication-activities.csv"
                >
                  <Button
                    onClick={generateCSV}
                    variant="contained"
                    sx={{
                      height: 30,
                      borderRadius: 2,
                      backgroundColor: "gray",
                      marginRight: 2,
                    }}
                  >
                    Generate CSV <FileDownloadIcon />
                  </Button>
                </CSVLink>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    height: 30,
                    marginRight: 2,
                    borderRadius: 2,
                    backgroundColor: colors.primary,
                  }}
                  startIcon={<FileDownloadIcon />}
                  disabled // Disabled if no data
                >
                  Generate CSV
                </Button>
              )}
              <Button
                href="/create-scientific"
                variant="contained"
                sx={{
                  height: 30,
                  marginTop: 0,
                  borderRadius: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Add new{" "}
              </Button>
            </Box>
          </Grid>

          {loadingScientificTable ? (
            <p>Loading data...</p>
          ) : (
            <MaterialReactTable
              columns={scientificColumns}
              data={myScientificData}
              enableRowActions
              renderRowActions={({ row }) => (
                <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                  <IconButton
                    color="secondary"
                    component={Link}
                    to={`edit-scientific/${row.original.id}`}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    component={Link}
                    to={`delete-scientific/${row.original.id}`}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )}
              classes={{
                root: "table-cell", // Appliquez la classe CSS aux cellules du tableau
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Home;
